(() => {
  const originAliases = {
    'Saudi Arabia': 'المملكة العربية السعودية',
    'El Salvador': 'السلفادور',
    'Costa Rica': 'كوستاريكا',
    Colombia: 'كولومبيا',
    Honduras: 'هندوراس',
    Ethiopia: 'إثيوبيا',
    Indonesia: 'إندونيسيا',
    Guatemala: 'غواتيمالا',
    Yemen: 'اليمن',
    Brazil: 'البرازيل'
  };
  const productNames = {
    en: {
      'colombia-goat': 'Colombia - Goat',
      'honduras-coffee-beans-cabanas': 'Honduras - Cabañas',
      'ethiopia-idido-natural': 'Ethiopia - Idido',
      'indonesia-java': 'Indonesia - Java',
      'ethiopia-guji': 'Ethiopia - Guji',
      guatemala: 'Guatemala - San Marcos',
      'colombia-la-recottei': 'Colombia - La Recotti',
      'ethiopia-guji-box-5-envelopes': 'Ethiopia Guji Box - 5 Envelopes',
      'colombia-huila-box-5-envelopes': 'Colombia Huila Box - 5 Envelopes',
      '20': 'Ethiopia Guji Box - 20 Envelopes',
      '10-1': 'Ethiopia Guji Box - 10 Envelopes',
      '10': 'Colombia Huila Box - 10 Envelopes',
      'saudi-arabia-jibal-al-arda': 'Saudi Arabia - Jibal Al Arda',
      'el-salvador-agua-caliante': 'El Salvador - Agua Caliente',
      'costa-rica-la-pascuala-natural': 'Costa Rica - Las Moras',
      'yemen-hraz': 'Yemen - Haraz (V60)',
      'brazil-rosa-branca': 'Brazil - Alta',
      'colombia-huila': 'Colombia - Huila',
      'product-28': 'Burlap Bag',
      'marid-red-travel-tumbler-12-oz': 'Marid Red Travel Tumbler - 12 oz',
      'uganda-manansi': 'Uganda Manansi',
      mblend: 'M Espresso Blend'
    },
    ar: {
      'colombia-goat': 'كولومبيا - قوت',
      'honduras-coffee-beans-cabanas': 'هندوراس - كابانياس',
      'ethiopia-idido-natural': 'إثيوبيا - إيديدو',
      'indonesia-java': 'إندونيسيا - جافا',
      'ethiopia-guji': 'إثيوبيا - قوجي',
      guatemala: 'غواتيمالا - سان ماركوس',
      'colombia-la-recottei': 'كولومبيا - لا ريكوتي',
      'ethiopia-guji-box-5-envelopes': 'علبة إثيوبيا قوجي — 5 أظرف',
      'colombia-huila-box-5-envelopes': 'علبة كولومبيا ويلا — 5 أظرف',
      '20': 'علبة إثيوبيا قوجي — 20 ظرفًا',
      '10-1': 'علبة إثيوبيا قوجي — 10 أظرف',
      '10': 'علبة كولومبيا ويلا — 10 أظرف',
      'saudi-arabia-jibal-al-arda': 'السعودية - جبال العارضة',
      'el-salvador-agua-caliante': 'السلفادور - أغوا كاليينتي',
      'costa-rica-la-pascuala-natural': 'كوستاريكا - لاس موراس',
      'yemen-hraz': 'اليمن - حراز (V60)',
      'brazil-rosa-branca': 'البرازيل - ألتا',
      'colombia-huila': 'كولومبيا - ويلا',
      'product-28': 'كيس خيش',
      'marid-red-travel-tumbler-12-oz': 'كوب سفر مارد الأحمر — 12 أونصة',
      'uganda-manansi': 'أوغندا ماناناسي',
      mblend: 'خلطة M للإسبريسو'
    }
  };
  let replacing = false;

  function currentLanguage() {
    return document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl' ? 'ar' : 'en';
  }

  function productHandleFromHref(href) {
    const match = String(href || '').match(/#\/product\/([^?&#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function repairHeader() {
    document.querySelectorAll('a[href$="/pages/wishlist"]').forEach(link => link.remove());

/* SEVEN 2026-09-29 final bilingual unit repair. */

;(() => {

  if (globalThis.__SEVEN_UNIT_REPAIR__) return; globalThis.__SEVEN_UNIT_REPAIR__ = true; const digits = { '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4', '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9' };
  
  
  const repairEnglishUnits = () => {
    if (currentLanguage() !== 'en') return;
    document.querySelectorAll('[data-variant-select], .product-info > span, .daily-card > div > p, .bestseller-card strong, .cart-items article > div > span').forEach(element => {
      const original = element.textContent;
      if (!/[٠-٩]|غرام|جرام|كيلو|كجم|كغم/.test(original)) return;
      const repaired = original
        .replace(/[٠-٩]/g, digit => digits[digit])
        .replace(/(\d+(?:[.,]\d+)?)\s*(?:كيلو\s*(?:غرام|جرام)?|كيلوغرام|كيلوجرام|كجم|كغم)/gi, '$1 kg')
        .replace(/(\d+(?:[.,]\d+)?)\s*(?:غرام(?:ات)?|جرام(?:ات)?)/gi, '$1 g')
        .replace(/\s{2,}/g, ' ')
        .trim();
      if (repaired !== original.trim()) element.textContent = repaired;
    });
  };
  new MutationObserver(repairEnglishUnits).observe(document.documentElement, { childList: true, subtree: true });
  addEventListener('hashchange', () => requestAnimationFrame(repairEnglishUnits));
  requestAnimationFrame(repairEnglishUnits); setInterval(repairEnglishUnits, 250);
})();

    const brand = document.querySelector('.site-header .brand');
    const source = document.querySelector('.search-brand img')?.src;
    if (!brand || !source) return;
    const images = [...brand.querySelectorAll('img')];
    if (!images.length) return;
    if (images[0].src !== source) images[0].src = source;
    if (images[0].className !== 'brand-logo brand-logo--mark') images[0].className = 'brand-logo brand-logo--mark';
    if (images[0].alt) images[0].alt = '';
    if (images[0].width !== 4002) images[0].width = 4002;
    if (images[0].height !== 5417) images[0].height = 5417;
    images.slice(1).forEach(image => image.remove());
  }

  function repairProductNames() {
    const language = currentLanguage();
    const names = productNames[language];
    document.querySelectorAll('a[href*="#/product/"]').forEach(link => {
      const handle = productHandleFromHref(link.getAttribute('href'));
      const name = names[handle];
      if (!name) return;
      const card = link.closest('.product-card, .daily-card, .bestseller-card');
      const title = card?.querySelector('h3 a, h3') || (link.closest('[data-search-results]') ? link.querySelector('strong') : null);
      if (title && title.textContent.trim() !== name) title.textContent = name;
      const ariaLabel = `${language === 'ar' ? 'عرض' : 'View'} ${name}`;
      if (link.hasAttribute('aria-label') && link.getAttribute('aria-label') !== ariaLabel) link.setAttribute('aria-label', ariaLabel);
      card?.querySelectorAll('img').forEach(image => { if (image.alt !== name) image.alt = name; });
    });
    const route = String(document.body.dataset.route || location.hash.slice(1)).split('?')[0];
    const handle = route.match(/^\/product\/(.+)$/)?.[1];
    const name = names[handle];
    if (name) {
      const heading = document.querySelector('.product-buy h1');
      const headingText = language === 'ar' ? name : `${name}.`;
      if (heading && heading.textContent.trim() !== headingText) heading.textContent = headingText;
      document.querySelectorAll('.product-gallery img').forEach(image => { if (image.alt !== name) image.alt = name; });
      const title = `${name} — ${language === 'ar' ? 'مارد القهوة' : 'Marid Coffee'}`;
      if (document.title !== title) document.title = title;
    }
  }

  function enforceReadableType() {
    const floor = currentLanguage() === 'ar' ? 15 : 14;
    const candidates = document.querySelectorAll('main p, main small, main label, main select, main a, main button, main span, main i, .site-header nav a, .header-tools button, .site-footer p, .site-footer small, .site-footer label, .site-footer a, .site-footer button, .site-footer span, .mobile-navigation a, .mobile-navigation button, .mobile-navigation small');
    candidates.forEach(element => {
      if (element.closest('svg, [aria-hidden="true"], .sr-only, .brand, .icon-button, .menu-button, .quantity')) return;
      const text = element.textContent.replace(/\s+/g, ' ').trim();
      if (!text || /^[+×−←→↗↵▶★0-9\s]+$/.test(text)) return;
      const size = parseFloat(getComputedStyle(element).fontSize);
      if (Number.isFinite(size) && size < floor) {
        element.style.setProperty('font-size', `${floor}px`, 'important');
        if (currentLanguage() === 'ar') element.style.setProperty('line-height', '1.7', 'important');
      }
    });
  }

  function repairCheckoutCopy() {
    if (document.documentElement.dir !== 'rtl') return;
    document.querySelectorAll('.cart-summary small').forEach(element => {
      if (element.textContent.includes('عبر شوبيفاي')) {
        element.textContent = element.textContent.replace('عبر شوبيفاي', 'عبر صفحة الدفع');
      }
    });
  }

  function repairEmptyArabicOriginRoute() {
    if (replacing || document.documentElement.dir !== 'rtl') return;
    const raw = location.hash.slice(1) || '/';
    const route = new URL(raw.startsWith('/') ? `https://marid.local${raw}` : `https://marid.local/${raw}`);
    if (route.pathname !== '/shop') return;
    const origin = route.searchParams.get('origin');
    const alias = originAliases[origin];
    if (!alias || !document.querySelector('.catalogue-results .empty-state')) return;
    if (document.querySelector('.catalogue-results .product-card')) return;
    replacing = true;
    route.searchParams.set('origin', alias);
    location.replace(`#${route.pathname}?${route.searchParams.toString()}`);
  }

  function repairReleaseDefects() {
    repairHeader();
    repairProductNames();
    enforceReadableType();
    repairCheckoutCopy();
    repairEmptyArabicOriginRoute();
  }

  new MutationObserver(repairReleaseDefects).observe(document.documentElement, { childList: true, subtree: true });
  addEventListener('hashchange', () => {
    replacing = false;
    requestAnimationFrame(repairReleaseDefects);
  });
  requestAnimationFrame(repairReleaseDefects);
})();

/* Stable graphic arrows: prevent iOS color-emoji fallback in storefront controls. */
(() => {
  const angles = { '↗': 0, '→': 45, '➡': 45, '↘': 90, '↓': 135, '⬇': 135, '↙': 180, '←': 225, '⬅': 225, '↖': 270, '↑': 315, '⬆': 315 };
  const pattern = /[↗→➡↘↓⬇↙←⬅↖↑⬆][\uFE0E\uFE0F]?/g;
  function repairArrows() {
    const root = document.querySelector('.seven-marid-storefront');
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.parentElement || node.parentElement.closest('script,style,svg,textarea,input,option,[contenteditable]')) continue;
      pattern.lastIndex = 0;
      if (pattern.test(node.nodeValue)) nodes.push(node);
    }
    nodes.forEach(node => {
      const fragment = document.createDocumentFragment();
      let previous = 0;
      pattern.lastIndex = 0;
      for (const match of node.nodeValue.matchAll(pattern)) {
        fragment.append(document.createTextNode(node.nodeValue.slice(previous, match.index)));
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('width', '1em'); svg.setAttribute('height', '1em');
        svg.setAttribute('class', 'marid-arrow'); svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.style.cssText = 'display:inline-block;vertical-align:-.12em;flex-shrink:0;overflow:visible;';
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M5 19 19 5M5 5h14v14');
        path.setAttribute('transform', 'rotate(' + angles[match[0][0]] + ' 12 12)');
        path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '1.8'); path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round');
        svg.append(path); fragment.append(svg); previous = match.index + match[0].length;
      }
      fragment.append(document.createTextNode(node.nodeValue.slice(previous)));
      node.replaceWith(fragment);
    });
  }
  const observer = new MutationObserver(repairArrows);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  repairArrows();
})();
